import type { GetReceivableShareConfigsParams } from './types';

export const receivableShareConfigKeys = {
  all: ['receivable-share-configs'] as const,
  lists: () => [...receivableShareConfigKeys.all, 'list'] as const,
  list: (filters?: GetReceivableShareConfigsParams) => [...receivableShareConfigKeys.lists(), filters] as const,
  details: () => [...receivableShareConfigKeys.all, 'detail'] as const,
  detail: (id: string) => [...receivableShareConfigKeys.details(), id] as const,
};

